export default "__VITE_ASSET__7c3c43fd__"